<template>
	<div>
		<a-row>
			<a-col :span="10">
				<div class="banner-title">
					
					<a-col :span="20"><h3><span style="color: red;">*</span>首页轮播图</h3></a-col>
					<!-- <a-col :span="4"><a-button type="primary" style="margin-top: 5px;" @click="submitSave()" html-type="submit" size="large">保存</a-button></a-col> -->
				</div>
				<div class="clearfix">
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccess"
						:before-upload="beforeAvatarUpload"
						:limit="6"
						multiple
						:on-exceed="handleExceed"
						:file-list="bannerList"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								轮播图(6张)
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
				</div>

				<div class="banner-title"><h3>公司logo</h3></div>
				<div class="clearfix">
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessLogo"
						:before-upload="beforeAvatarUploadLogo"
						:limit="1"
						multiple
						:on-exceed="handleExceed"
						:file-list="logoList"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								logo(1张)
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="logoRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					
				</div>

				<div class="banner-title"><h3>荣誉资质</h3></div>
				<div class="clearfix">
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessHonour"
						:before-upload="beforeAvatarUploadHonor"
						:limit="15"
						multiple
						:on-exceed="handleExceed"
						:file-list="honorList"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								荣誉资质
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="honorRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					
					
				</div>

				<div class="banner-title"><h3>公司实景</h3></div>
				<div class="clearfix">
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessCompany"
						:before-upload="beforeAvatarUploadCompany"
						:limit="15"
						multiple
						:on-exceed="handleExceed"
						:file-list="companyImgList"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								公司实景
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="companyPicutreRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
						
					
				</div>
				
				<div class="banner-title"><h3><span style="color: red;">*</span>营业凭证(一经上传不可修改)</h3></div>
				<div class="clearfix">
					<el-upload
							list-type="picture-card"
							:action="domain"
							:data="QiniuData"
							:on-error="uploadError"
							:on-success="uploadSuccessBusiness"
							:before-upload="beforeAvatarUploadBusiness"
							:limit="1"
							multiple
							:on-exceed="handleExceed"
							:file-list="businessPhoto"
						>
							<i slot="default" class="el-icon-plus">
								<div style="font-size: 14px;">
									营业执照(1张)
								</div>
							</i>
							<div slot="file" slot-scope="{ file }">
								<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
								<span class="el-upload-list__item-actions">
									<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
									<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
									<span v-if="update1" class="el-upload-list__item-delete" @click="businessPhotoRemove(file)"><i class="el-icon-delete"></i></span>
								</span>
							</div>
						</el-upload>
					
				</div>
					
				<div>
					<el-upload
						list-type="picture-card"
						:action="domain"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessProof"
						:before-upload="beforeAvatarUploadProof"
						:limit="1"
						multiple
						:on-exceed="handleExceed"
						:file-list="proofPhoto"
					>
						<i slot="default" class="el-icon-plus">
							<div style="font-size: 14px;">
								网店凭证(1张)
							</div>
						</i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="update2" class="el-upload-list__item-delete" @click="proofPhotoRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					
				</div>
				<div class="banner-title"><h3><span style="color: red;">*</span>商铺资料</h3></div>
				
				<a-form :form="form">
					<a-form-item label="公司/工厂名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-input  @change="companyChange" v-decorator="['company', { rules: [{ required: true, message: '请输入工厂名称!' }] }]" placeholder="请输入工厂名称" />
					</a-form-item>
					
					
					
					<a-form-item label="成立日期" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-date-picker
							:locale="zh_CN"
							v-decorator="['establishDate', { initiaValue: '', rules: [{ required: true, message: '请输入公司/工厂成立日期' }] }]"
							placeholder="请输入成立日期"
							@change="onChangeDate"
						/>
					</a-form-item>
					<a-form-item label="联系电话" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-input @change="servicePhoneChange" v-decorator="['servicePhone', { rules: [{ required: true, message: '请输入店铺联系电话!' }] }]" placeholder="请输入联系电话" />
					</a-form-item>
					<a-form-item label="主营产品" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-input v-decorator="['main', { rules: [{ required: true, message: '请输入店铺主营产品!' }] }]" placeholder="请输入店铺主营产品" />
					</a-form-item>

					<a-form-item label="企业介绍" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-textarea @change="introChange" v-decorator="['intro', { rules: [{ required: true, message: '请输入企业介绍!' }] }]" placeholder="请填写企业介绍...." :rows="6" />
					</a-form-item>
					<a-form-item label="企业地址" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-input @change="addressDetailChange" v-decorator="['addressDetail', { rules: [{ required: true, message: '请输入企业地址!' }] }]" placeholder="请输入企业地址" />
						<Map class="map" @localhostMap="localhostMap"></Map>
					</a-form-item>
					<a-button type="primary" id="submit-save" @click="handleSubmit" style="margin-top: 5px;display:none;" size="large"></a-button>
				</a-form>
			</a-col>
		<a-affix :offset-top="10" :offset-bottom="0">
			<a-col :span="10">
			</a-col>
			<!-- <a-col :span="10" class="preview_phone">
				
					<div class="phone-body">
						<div class="storeBanner">
							<a-carousel :afterChange="onChange" autoplay>
								<div v-for="(item, index) in bannerList" :key="index">
									<div><img class="banner-img" :src="item.url" alt="" /></div>
								</div>
							</a-carousel>
						</div>
						<a-row class="store-title mobile">
							<a-col :span="4" class="title-avatar"><a-avatar :size="35" :src="data.logo" /></a-col>
							<a-col :span="15">
								<div class="title-company-name">
								<span v-if="data.name != undefined && data.name.length > 10">
								{{ data.name.substring(0,10) }}...
								</span>
								<span v-else>
								{{ data.name }}
								</span>
								</div>
								<div><img style="width: 51px;" src="http://cdn.diqwl.com/store_banner_company-rz.png" alt="" /></div>
							</a-col>
							<a-col :span="5">
								<div>
									<button class="all_list_brands_title_details_btn" id="brands_button">
										<span class="glyphicon">
											<a-icon type="plus" />
											<span style="font-size: 10px;">关注</span>
										</span>
									</button>
								</div>
							</a-col>
						</a-row>
						<div class="line mobile"></div>
						<div class="store-info mobile">
							<div class="info-title">
								<div>
									<img src="../../static/left.png" alt="" />
									<span>基本资料</span>
									<img src="../../static/right.png" alt="" />
								</div>
							</div>
							<div class="info-content">
								<div class="info-intro">{{ data.intro }}</div>
								<div class="info-icon">
									<img class="icon" src="../../static/phone-icon.png" alt="" />
									<span class="icon-right-text">
										联系方式：
										<span style="color: deepskyblue;">{{ data.servicePhone }}</span>
									</span>
								</div>
								<div class="info-icon">
									<img class="icon" src="../../static/company-icon.png" alt="" />
									<span class="icon-right-text">成立日期：{{ establishDate }}</span>
								</div>
								<a-row class="info-icon">
									<a-col :span="2"><img class="icon" src="../../static/address-icon.png" alt="" /></a-col>
									<a-col :span="22">
										<span class="icon-right-text">地址：{{ data.addressDetail }}</span>
									</a-col>
								</a-row>
							</div>
						</div>
						<div class="line mobile"></div>
						<div class="honor-info mobile">
							<div class="info-title">
								<div>
									<img src="../../static/left.png" alt="" />
									<span>荣誉资料</span>
									<img src="../../static/right.png" alt="" />
								</div>
							</div>
							<div>
								<ul class="honor-info-img">
									<li class="item">
										<span :key="index" v-for="(item, index) in honorList"><img :src="item.url" :alt="index" /></span>
									</li>
								</ul>
							</div>
						</div>
						<div class="line mobile"></div>
						<div class="company-info mobile">
							<div class="info-title">
								<div>
									<img src="../../static/left.png" alt="" />
									<span>公司环境</span>
									<img src="../../static/right.png" alt="" />
								</div>
								<div class="company-img">
									<span :key="index" v-for="(item, index) in companyImgList"><img :src="item.url" :alt="index" /></span>
								</div>
							</div>
						</div>
					</div>
				
				<div class="hint">
					<a-icon type="warning" />
					该模型仅供参考，具体展示以手机为主
				</div>
			</a-col> -->
			<!-- <a-col :span="10">
				 </a-col>-->
			<a-col :span="10">
				<div class="submit-save">
					<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
						<a-alert message="点击保存" description="保存后将会重新审核信息" type="error" showIcon >
							<a-icon type="warning" slot="icon"/>
						</a-alert>
						<a-button type="primary" style="margin-top: 5px;" @click="submitSave()" html-type="submit" size="large">保存</a-button>
					</a-form-item>
				</div>
			</a-col>
			</a-affix>
		</a-row>
	</div>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import api from '../../api/Api.js';
import Map from '../utils/map.vue';

export default {
	components: {
		Map
	},
	data() {
		return {
			zh_CN,
			previewVisible: false,
			previewImage: '',
			bannerList: [],
			logoList: [],
			honorList: [],
			companyImgList: [],
			businessPhoto:[],
			proofPhoto:[],
			form: this.$form.createForm(this, { name: 'dynamic_rule' }),
			QiniuData: {
				key: '', //图片名字处理
				token: '' //七牛云token
			},
			domain: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
			qiniuaddr: 'http://cdn.diqwl.com', // 七牛云的图片外链地址
			pictureAddress: '',
			establishDate: '2001-04-01',
			data: {
				address: '',
				addressDetail: '',
				cover: [],
				companyHonor: [],
				img: [],
				businessPhoto:[],
				intro: '',
				logo: '',
				name: '',
				servicePhone: '',
				type: 'PERSON',
				longitude: 113.948419,
				latitude: 22.476874
			},
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			update1:true,
			update2:true
		};
	},
	mounted() {
		this.getQiniuToken();
		this.getInfo();
	},
	methods: {
		moment,
		modifyInfo() {
			let url = 'api/store/v1/admin/modify';
			let parm = this.data;

			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					this.$message.success('修改成功！');
				} else {
					this.$message.error(rest.message);
				}
			});
		},
		submitSave() {
			document.getElementById('submit-save').click();
		},
		handleCancel() {
			this.previewVisible = false;
		},
		handlePreview(file) {
			this.previewImage = file.url || file.thumbUrl;
			this.previewVisible = true;
		},
		onChange(a, b, c) {
			// console.log(a, b, c);
		},
		localhostMap(localDate) {
			this.data.address = localDate.address;
			this.data.longitude = localDate.longitude;
			this.data.latitude = localDate.latitude;
			console.log(this.data.address);
		},
		uploadSuccess(response, file, fileList) {
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			this.bannerList.push(obj);
		},
		uploadSuccessLogo(response, file, fileList){
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			this.data.logo = obj.url;
			this.logoList.push(obj);
		},
		uploadSuccessHonour(response, file, fileList){
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			this.honorList.push(obj);
		},
		uploadSuccessCompany(response, file, fileList){
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			this.companyImgList.push(obj);
		},
		uploadSuccessBusiness(response, file, fileList){
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			this.businessPhoto.push(obj);
		},
		uploadSuccessProof(response, file, fileList){
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			this.proofPhoto.push(obj);
		},
		//请求后台拿七牛云token
		getQiniuToken() {
			const that = this;
			let url = 'api/file/v1/qiniu/getToken';
			let parm = 1;
			
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					this.QiniuData.token = res.data.data.token;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		beforeAvatarUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
			
		},
		beforeAvatarUploadLogo(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
			
		},
		beforeAvatarUploadHonor(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		bannerRemove(file) {
			var index = this.bannerList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.bannerList.splice(index, 1);
		},
		logoRemove(file) {
			var index = this.logoList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.logoList.splice(index, 1);
			this.data.logo = ""
		},
		honorRemove(file) {
			var index = this.honorList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.honorList.splice(index, 1);
		},
		beforeAvatarUploadProof(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		beforeAvatarUploadBusiness(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		beforeAvatarUploadCompany(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
			
		},
		businessPhotoRemove(file) {
			var index = this.businessPhoto.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.businessPhoto.splice(index, 1);
		},
		proofPhotoRemove(file){
			var index = this.proofPhoto.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.proofPhoto.splice(index, 1);
		},
		companyPicutreRemove(file) {
			var index = this.companyImgList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.companyImgList.splice(index, 1);
		},
		//***************************保存提交**********************************
		handleSubmit() {
			const that = this;

			this.$confirm({
				title: '确定保存吗？',
				content: '保存后将会重新审核信息,确定保存信息吗?',
				onOk() {
					if (that.checkUrl()) {
						that.$message.error('图片信息未完善！');
						return;
					}
					const bannerList = [];
					const honorList = [];
					const companyImgList = [];
					const businessPhoto = [];
					const proofPhoto = [];
					that.businessPhoto.forEach((item, index, array) => {
						businessPhoto.push(item.url);
					});
					that.proofPhoto.forEach((item, index, array) => {
						proofPhoto.push(item.url);
					});
					that.bannerList.forEach((item, index, array) => {
						bannerList.push(item.url);
					});
					that.honorList.forEach((item, index, array) => {
						honorList.push(item.url);
					});
					that.companyImgList.forEach((item, index, array) => {
						companyImgList.push(item.url);
					});

					that.form.validateFields((err, values) => {
						console.log(err)
						
						if (!err) {
							values.establishDate = that.establishDate;
							that.data = {
								addressDetail: values.addressDetail,
								establishDate: values.establishDate,
								cover: bannerList,
								businessPhoto:businessPhoto,
								proofPhoto:proofPhoto,
								companyHonor: honorList,
								img: companyImgList,
								intro: values.intro,
								logo: that.logoList[0].url,
								name: values.company,
								servicePhone: values.servicePhone,
								type: 'PERSON',
								address: that.data.address,
								longitude: that.data.longitude,
								latitude: that.data.latitude,
								main: values.main
							};
							that.modifyInfo();
						}else{
							that.$message.error('商铺资料信息未完善！');
						}
						return new Promise((resolve, reject) => {
							setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
						}).catch(() => console.log('Oops errors!'));
					});
				},
				onCancel() {
					that.$message.warning('你点击了取消');
				}
			});

			console.log('确认提交');
		},
		checkUrl() {
			if(this.businessPhoto.length == 0){
				this.$message.error('营业执照图片未完善！');
				return true;
			}
			if(this.bannerList.length == 0){
				this.$message.error('首页轮播图图片未完善！');
				return true;
			}
			if(this.honorList.length == 0){
				this.$message.error('荣誉资料图片未完善！');
				return true;
			}
			if(this.companyImgList.length == 0){
				this.$message.error('公司实景图片未完善！');
				return true;
			}
			if(this.proofPhoto.length == 0){
				this.$message.error('网店凭证图片未完善！');
				return true;
			}
			if (this.logoList.length == 0) {
				this.$message.error('店铺LOGO图片未完善！');
				return true;
			}
			return false;
		},
		onChangeDate(date, dateString) {
			this.establishDate = dateString;
		},
		getInfo() {
			const that = this;
			let url = 'api/store/v1/admin/info';
			let parm = 1;

			api.postRequest(url, parm, res => {
				console.log(res);

				const rest = res.data;
				if (rest.status == 200) {
					this.bannerInfo(rest.data.cover);
					this.businessPhotoInfo(rest.data.businessPhoto);
					this.proofPhotoInfo(rest.data.proofPhoto)
					this.companyInfo(rest.data.img);
					this.formInfo(rest.data);
					this.logoInfo(rest.data.logo);
					this.companyHonorInfo(rest.data.companyHonor);
					that.data = rest.data;
				} else {
					this.$message.error(rest.message);
				}
			});
		},
		uploadError(err, file, fileList) {
			this.$message.error("上传出错，请重试!");
		},
		companyHonorInfo(honorList) {
			if (honorList == undefined) {
				return;
			}
			honorList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.honorList.push(obj);
			});
		},
		logoInfo(logoList) {
			if (logoList == undefined) {
				return;
			}
			var obj = {
				status: 'done'
			};
			obj.uid = 1;
			obj.name = 'logo.jpg';
			obj.url = logoList;
			this.logoList.push(obj);
		},
		proofPhotoInfo(proofPhoto){
			if (proofPhoto == undefined) {
				return;
			}
			this.update2 = false;
			proofPhoto.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.proofPhoto.push(obj);
			});
		},
		businessPhotoInfo(bannerList) {
			if (bannerList == undefined) {
				return;
			}
			this.update1 = false;
			bannerList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.businessPhoto.push(obj);
			});
		},
		bannerInfo(bannerList) {
			if (bannerList == undefined) {
				return;
			}
			bannerList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.bannerList.push(obj);
			});
		},
		companyInfo(companyImgList) {
			if (companyImgList == undefined) {
				return;
			}
			companyImgList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.companyImgList.push(obj);
			});
		},
		formInfo(rest) {
			if (rest.name == undefined) {
				console.log("返回")
				return;
			}
			this.form.setFieldsValue({
				company: rest.name,
				servicePhone: rest.servicePhone,
				addressDetail: rest.addressDetail,
				intro: rest.intro,
				main: rest.main,
				establishDate: moment(rest.establishDate == undefined ? new Date() : rest.establishDate, 'YYYY-MM-DD')
			});
			this.establishDate = rest.establishDate;
		},
		companyChange(value){
			this.data.name = value.target.value;
		},
		servicePhoneChange(value){
			this.data.servicePhone = value.target.value;
		},
		introChange(value){
			this.data.intro = value.target.value;
		},
		addressDetailChange(value){
			this.data.addressDetail = value.target.value;
		},
		uploadImgChange(a,b,c){
			 console.log(a)
			// console.log(b)	
			// console.log(c)
		},
		handleExceed(files, fileList) {
			this.$message.warning(`图片选择已上限，如需更换，请删除上一张图片在重新选择！`);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
	}
};
</script>
<style scoped>
.submit-save {
	margin-top: 40px;
}

.hint {
	margin-top: 85px;
	font-size: 22px;
	text-align: center;
}

.company-info {
	height: 100%;
	padding: 1%;
}
.company-img img {
	width: 235px;
	margin-top: 10px;
}

.info-intro {
	height: 40px;

	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

/* banner-title */
.banner-title {
	border-bottom: 0.5px solid gray;
	margin-bottom: 30px;
	margin-top: 10px;
}
.map {
	height: 450px;
	width: 700px;
	margin-top: 20px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
	font-size: 32px;
	color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
	margin-top: 8px;
	color: #666;
}
.preview_phone {
	width: 670px;
	height: 670px;
	background-image: url('../../static/phone.png');
	background-size: 100%;
}
.phone-body {
	height: 462px;
	overflow: scroll;
	margin-top: 102px;
}
.phone-body::-webkit-scrollbar {
	display: none;
}

/* For demo */
.ant-carousel >>> .slick-slide {
	text-align: center;
	height: 127.5px;
	line-height: 160px;
	background: #364d79;
	overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
	color: #fff;
}

.storeBanner {
	width: 255px;
	margin: 0 auto;
}

.banner-img {
	width: 260px;
}

.store-title {
	height: 55px;
}
.title-avatar {
	height: 55px;
	padding-top: 10px;
	padding-left: 5px;
}
.title-company-name {
	padding-top: 8px;
	font-size: 12px;
	font-weight: bold;
}

.mobile {
	width: 255px;
	margin: 0 auto;
}
.line {
	border: 2px solid gainsboro;
}
.store-info {
	height: 160px;
}
.info-title {
	height: 20px;
	text-align: center;
	font-weight: bold;
	margin-top: 5px;
}
.info-content {
	padding: 3%;
	height: 100%;
	font-size: 12px;
}

.all_list_brands_title_details_btn {
	width: 50px;
	height: 25px;
	font-size: 9px;
	line-height: 1.428571429;
	border-radius: 15px;
	margin-top: 10px;
	float: left;
	background-image: linear-gradient(to left, Orange, DarkOrange);
	border: 1px solid #f4a460;
	color: white;
}

.info-icon {
	display: inline;
	float: left;
	margin-top: 5px;
	margin-left: 5px;
	font-weight: bold;
	width: 100%;
}
.icon {
	width: 20px;
	display: inline;
	float: left;
}

.icon-right-text {
	margin-left: 15px;
	font-size: 12px;
	float: left;
}

.honor-info {
	height: 145px;
}

.honor-info-img {
	overflow-x: auto; /*	设置x轴可滑动 */
	list-style: none; /*去掉li上的小点 */
	white-space: nowrap; /*元素不换行 */
	width: auto;
	padding: 0;
}
.item {
	margin-left: 20px;
	display: inline-block; /*让所有的li在一行 注意这里不能用*/
	float: left; /* 因为设置float后里超过一屏后会自动换行 */
	padding: 0;
	margin-top: 10px;
}

.honor-info-img img {
	width: 150px;
	margin-left: 10px;
	max-height: 110px;
}

.honor-info-img::-webkit-scrollbar {
	display: none;
}

</style>
